module.exports = __webpack_public_path__ + "img/logo.badc059d.png";